import React, { useEffect } from 'react';
import { List, Datagrid, FunctionField } from 'react-admin';

function EdificioCorporativoList(props: any) {
  useEffect(() => {
    document.title = 'FG Edificio Corporativo - Gasco';
  }, []);

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <FunctionField
          label="El Edificio Hoy"
          render={(record: any) => {
            const text = record.descripcion?.[0]?.children?.[0]?.text || '';
            return <span>{text ? `${text.substring(0, 100)}...` : 'Sin contenido'}</span>;
          }}
        />

        <FunctionField
          label="Historia y Arquitectura"
          render={(record: any) => {
            const text = record.detalle?.[0]?.children?.[0]?.text || '';
            return <span>{text ? `${text.substring(0, 100)}...` : 'Sin contenido'}</span>;
          }}
        />

        <FunctionField
          label="Slides Hero"
          render={(record: any) => {
            const total = Array.isArray(record.hero) ? record.hero.length : 0;
            return <span>{total}</span>;
          }}
        />
      </Datagrid>
    </List>
  );
}

export default EdificioCorporativoList;
